import {useEffect, useRef, useState} from 'react';
import {Box, Button, IconButton, makeStyles, TextField, Tooltip} from '@material-ui/core';
import CreatorBtn from '../../../../atoms/creator/experienceBuilderEnterBtn';
import clsx from 'clsx';
import {useDispatch, useSelector} from 'react-redux';
import {moveNextPage, updateUserMetrics} from "../../../../../store/actions/creator/creatorExperienceBuilder";
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
import CustomSnackBar from './../../../creator/experienceManager/participantsDashboard/component/CustomSnackBar';
import {CSVLink} from "react-csv";
import CSVReader from 'react-csv-reader';
import UtilService from "../../../../../helper/service";
import {useHistory, useLocation} from "react-router";
import Messages from "../../../../../helper/messages"

const useStyles = makeStyles(() => ({
  optionText: {
    color: '#697683',
    fontSize: 30,
    textAlign: 'center',
    fontWeight: 'lighter',
    marginTop: -25,
  },
  info: {
    color: '#697683',
    fontSize: 18,
    maxWidth: 570
  },
  titleBox: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center'
  },
  table: {
    border: '17px solid #FFE9C4',
    borderRadius: 17,
    width: 380,
    marginLeft: 12
  },
  tr: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    backgroundColor: '#fff'
  },
  td: {
    border: '1px solid #707070',
    height: 34,
    padding: 5,
    display: 'flex',
    flex: 1,
    fontFamily: 'roboto-regular',
    alignItems: 'center',
    color: '#717E8B',
    overflow: 'hidden',
    width: '100%'
  },
  agenda: {
    color: '#212D40',
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'left',
    marginTop: 10,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  hover: {
    backgroundColor: '#EEF4FD',
    color: '#212D40',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  icons: {
    position: 'absolute',
    right: -160,
    marginTop: 5
  },
  icon: {
    marginLeft: 5,
    '&:hover': {
      background: '#e0e0e0',
      borderRadius: 5
    }
  },
  downloadicon: {
    marginLeft: 5,
    borderRadius: 5,
    background: '#F0F0F0',
    '&:hover': {
      background: '#e0e0e0',
      borderRadius: 5
    },
  },
  doneBtn: {
    margin: 0,
    padding: 0,
    height: 22,
    background: '#697683',
    borderRadius: 4,
    color: '#fff',
    fontSize: 9,
    marginTop: -13,
    marginLeft: 5,
    '&:hover': {
      background: '#343B43'
    }
  },
  hidden: {
    display: 'none'
  },
  textField: {
    width: '100%',
    "& .MuiOutlinedInput-inputMarginDense": {
      margin: "0!important",
      border: '1px solid #697683',
      padding: 2,
      borderRadius: 3,
      paddingLeft: 6
    }
  },
  ml: {
    right: -80
  },
  csvBtn: {
    width: 100,
    height: 37,
    borderRadius: 4,
    backgroundColor: '#F0F0F0',
    fontSize: '0.875rem',
    fontFamily: 'roboto-regular',
    color: '#697683',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
    '& input': {
      display: 'none'
    },
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: '#e0e0e0',
    },
  },
  csvLabel: {
    cursor: 'pointer',
    padding: 8
  },
  addAgendaHover: {
    '&:hover': {
      color: '#0f9fef'
    }
  },
  p7: {
    padding: 7
  }
}));

interface IAgendaItem {
  title: string
  // start: string
  // end: string
}
let message = "";
function LiveExperienceAddAgenda() {

  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const [initStepHover, setInitStepHover] = useState(-1);
  const [editIndex, setEditIndex] = useState(-1);
  const { userMetrics, page } = useSelector((state: any) => state.creatorExperienceBuilder);
  const { modLastActivePage } = userMetrics;
  const [schedules, setSchedules] = useState<IAgendaItem[]>(userMetrics.moderatedAgendaSchedules);
  const textAreaRef = useRef<any>(null);
  const [deletedItem, setDeletedItem] = useState(false);
  const [isShownSnackAlert, setShownSnackAlert] = useState(false);
  const [csvData, handleCsvData] = useState<any[]>([]);
  const [randomID, setRendomId] = useState(1);

  const agendaTemplate = [
    { no: "1", agenda_name: "Agenda Item" },
    { no: "2", agenda_name: "Agenda Item" }
  ];

  const parseOptions = {
    header: false,
    skipEmptyLines: true
  };

  useEffect(() => {
    if (history.location.hash !== '#agenda') {
      UtilService.addHashTag(history, location.pathname, 'agenda');
    }
  }, []);

  useEffect(() => {
    if (!schedules.length && !deletedItem) {
      const blankEntry = [];
      blankEntry.push({
        title: 'Agenda Item Name',
        // start: '10:00 AM',
        // end: '12:00 AM'
      });
      setSchedules(blankEntry)
    }
  }, [schedules]);

  const setOnChangeTitle = (e: any, index: number) => {
    const old: any = [...schedules];
    old[index][e.target.name] = e.target.value;
    onSaveSchedules(old);
  };

  const removeItem = (index: number) => {
    const old = [...schedules];
    old.splice(index, 1);
    onSaveSchedules(old);
    setDeletedItem(true)
  };

  const addItem = () => {
    const old = [...schedules]
    old.push({
      title: 'Agenda Item Name',
      // start: '10:00 AM',
      // end: '12:00 AM'
    });
    onSaveSchedules(old);
    setEditIndex(schedules.length)
  };

  const onSaveSchedules = (old: IAgendaItem[]) => {
    setSchedules([...old]);
    dispatch(updateUserMetrics('moderatedAgendaSchedules', old))
  }

  const handleUserKeyPress = async (event: any) => {
    if (event.keyCode === 13) {
      editIndex !== -1 ? setEditIndex(-1) : goNext();
    }

    if (event.keyCode === 86 && (event.ctrlKey || event.metaKey)) {
      const old = [...schedules];
      textAreaRef.current.select();

      setTimeout(() => {

        const csvText = textAreaRef.current.value;
        if (old[editIndex]) {
          old[editIndex].title = csvText
        }

        onSaveSchedules(old);
      }, 500)
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleUserKeyPress);
    return () => {
      window.removeEventListener('keydown', handleUserKeyPress);
    };
  });

  const goNext = () => {
    dispatch(moveNextPage(page + 1));
    (modLastActivePage < page + 1) && dispatch(updateUserMetrics('modLastActivePage', page + 1));
  };

  const handleOnDragEnd = (result: any) => {
    setEditIndex(-1);
    if (!result.destination) return;
    const items = Array.from(schedules);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    onSaveSchedules(items);
  };

  const handleForceCSV = (rows: any, fileInfo:any) => {
    const array = ['application/vnd.ms-excel','text/plain','text/csv','text/tsv'];
    if(array.indexOf(fileInfo.type) === -1){
      message = Messages.NOTIFICATIONS.ERROR.csvFileValidation;
      setShownSnackAlert(true);
      return
    }
    // let old = [...schedules]
    const old: any = [];
    let skippedRows = 0;

    rows.forEach((row: any, index: number) => {
      if (index !== 0) { // CSV Header
        if (row[0] && row[1]) {
          old.push({
            title: row[1],
          })
        } else {
          skippedRows++
        }
      }
    });

    if (old.length === 0) {
      message = Messages.NOTIFICATIONS.ERROR.blankCsvError;
      setShownSnackAlert(true);
      setRendomId(randomID + 1);
      return
    }

    setSchedules(old);
    onSaveSchedules(old);
    if (skippedRows) {
      message = `${skippedRows} rows skipped.`;
      setShownSnackAlert(true)
    }
    setRendomId(randomID+1)
  };

  const hideSnackAlert = () => {
    setShownSnackAlert(false);
  };

  const csvHeaders = [
    { label: "No", key: "no" },
    { label: "Agenda Name", key: "agenda_name" },
    // { label: "Start", key: "start" },
    // { label: "End", key: "end" }
  ];

  const handleCSVDownload = () => {
    handleCsvData(agendaTemplate);
  }

  return (
    <>
      <p className="creator-title mt-65">
        Excellent. Almost finished.
      </p>

      <p className='creator-main-title'>
        What’s the agenda / schedule?
      </p>

      <p className={classes.optionText}>(Optional)</p>

      <Box alignItems="center" display="flex" flexDirection='column'>
        <p className={classes.info}>If you give us the agenda now, we can make it much easier to look at what may be driving high and low points of the experience.</p>

        <form>
          <textarea
            ref={textAreaRef}
            style={{ position: 'absolute', left: -10000 }}
          />
        </form>
        <div className={classes.table} style={{ visibility: ((schedules && schedules.length > 0) ? 'visible' : 'hidden') }} >
          {schedules.length > 0 && <>
            <DragDropContext onDragEnd={handleOnDragEnd}>
              <Droppable droppableId="characters">
                {(provided: any) => (
                  <div className="characters" {...provided.droppableProps} ref={provided.innerRef}>
                    {
                      schedules.map((item, index) =>
                        <Draggable key={index} draggableId={index + ""} index={index}>
                          {(provided: any) => (
                            <div
                              ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}
                              className={clsx(classes.tr, initStepHover === index && classes.hover)}
                              onMouseOver={() => setInitStepHover(index)}
                            >
                              <div className={classes.td} onClick={() => { setEditIndex(index) }}>
                                {editIndex !== index && item.title}
                                {
                                  editIndex === index &&
                                  <TextField
                                    autoFocus
                                    onFocus={event => { event.target.select() }}
                                    className={classes.textField}
                                    value={item.title}
                                    size="small"
                                    variant="outlined"
                                    name="title"
                                    onChange={(e) => setOnChangeTitle(e, index)}
                                  />
                                }
                              </div>
                              <div className={clsx(classes.icons, initStepHover !== index && classes.hidden, editIndex !== index && classes.ml)}>
                                <img src={'/assets/icons/experiencebuilder/edit-icon.svg'} alt="{}" className={classes.icon} onClick={() => setEditIndex(index)} />
                                <img src={'/assets/icons/experiencebuilder/trash-icon.svg'} alt="{}" className={classes.icon} onClick={() => removeItem(index)} />
                                {editIndex === index && <Button className={classes.doneBtn} onClick={() => setEditIndex(-1)}>Save</Button>}
                              </div>
                            </div>
                          )}
                        </Draggable>
                      )}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </>}
        </div>

        <Box display="flex" justifyContent='center' flexDirection='row' style={{ minWidth: 500, marginTop: 15 }}>
          <div className={classes.titleBox}>
            <p className={`${classes.agenda} ${classes.addAgendaHover}`} onClick={addItem}>+ agenda item</p>
          </div>
          <div className={classes.titleBox} key={randomID}>
            <CSVReader
              cssClass={classes.csvBtn}
              cssLabelClass={classes.csvLabel}
              label="Upload CSV"
              onFileLoaded={handleForceCSV}
              parserOptions={parseOptions}
            />

            <CSVLink data={csvData} headers={csvHeaders} onClick={handleCSVDownload} filename={`agenda.csv`}>
              <div className={clsx(classes.downloadicon)}>
                <Tooltip title="Download CSV Template" placement="bottom">
                  <IconButton aria-label="download" className={classes.p7} size="medium">
                    <img src={'/assets/icons/download_icon.svg'} alt="CSV Download" />
                  </IconButton>
                </Tooltip>
              </div>
            </CSVLink>
          </div>
        </Box>
      </Box>
      <CustomSnackBar type={"error"} message={message} open={isShownSnackAlert} onClose={hideSnackAlert} />
      <br />

      <CreatorBtn goNext={goNext} title="Proceed to Review" isRight={true} />

      <br /><br />

    </>
  )
}

export default LiveExperienceAddAgenda;
